export function LinearCloseCirlce({ className = '' }: Readonly<{ className?: string }>) {
  return (
    <span className={`icon ${className}`}>
      <svg
        width="1em"
        height="1em"
        viewBox="0 0 30 30"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M15 2.3125C21.9983 2.3125 27.6875 8.00171 27.6875 15C27.6875 21.9983 21.9983 27.6875 15 27.6875C8.00171 27.6875 2.3125 21.9983 2.3125 15C2.3125 8.00171 8.00171 2.3125 15 2.3125ZM15 2.6875C8.21079 2.6875 2.6875 8.21079 2.6875 15C2.6875 21.7892 8.21079 27.3125 15 27.3125C21.7892 27.3125 27.3125 21.7892 27.3125 15C27.3125 8.21079 21.7892 2.6875 15 2.6875Z"
          fill="currentColor"
          stroke="currentColor"
          strokeWidth="1.5"
        />
        <path
          d="M18.5371 11.2783C18.5906 11.2784 18.6367 11.298 18.6689 11.3301C18.7012 11.3624 18.7207 11.4091 18.7207 11.4629C18.7207 11.5165 18.7011 11.5625 18.6689 11.5947L11.585 18.6787L11.5762 18.6885C11.5713 18.6937 11.5599 18.7026 11.5391 18.7109C11.5173 18.7195 11.4901 18.7256 11.4619 18.7256C11.4354 18.7256 11.4116 18.72 11.3916 18.7119C11.3724 18.7041 11.351 18.6918 11.3291 18.6699C11.297 18.6377 11.2774 18.5916 11.2773 18.5381C11.2773 18.4844 11.2969 18.4376 11.3291 18.4053L18.4043 11.3301C18.4366 11.2978 18.4834 11.2783 18.5371 11.2783Z"
          fill="currentColor"
          stroke="currentColor"
          strokeWidth="1.5"
        />
        <path
          d="M11.4619 11.2783C11.5154 11.2784 11.5615 11.298 11.5938 11.3301L18.6689 18.4053C18.7012 18.4376 18.7207 18.4843 18.7207 18.5381C18.7206 18.5917 18.7012 18.6377 18.6689 18.6699C18.647 18.6919 18.6257 18.7041 18.6064 18.7119C18.5866 18.7199 18.5635 18.7255 18.5371 18.7256C18.5106 18.7256 18.4868 18.72 18.4668 18.7119C18.4476 18.7041 18.4262 18.6918 18.4043 18.6699L11.3291 11.5947C11.297 11.5625 11.2774 11.5164 11.2773 11.4629C11.2773 11.4091 11.2968 11.3624 11.3291 11.3301C11.3614 11.2978 11.4081 11.2783 11.4619 11.2783Z"
          fill="currentColor"
          stroke="currentColor"
          strokeWidth="1.5"
        />
      </svg>
    </span>
  );
}
